import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useCallback } from '@redneckz/uni-jsx/lib/hooks';
import { useIntersectionObserver, } from '../../hooks/useIntersectionObserver.js';
import { style } from '../../utils/style.js';
export const SwipeListItem = JSX(({ className, style: inlineStyle, idx, activeIndex, observerOptions, children, onIntersection, }) => {
    const observerCallback = useCallback((entries) => {
        if (entries.length && onIntersection) {
            onIntersection(idx || 0, entries[entries.length - 1]);
        }
    }, [onIntersection, idx]);
    const ref = useIntersectionObserver(observerCallback, observerOptions);
    return (_jsx("div", { className: style('inline-block snap-always box-border', className), style: inlineStyle, "aria-current": Boolean(idx === activeIndex), ref: ref, role: "listitem", children: children }));
});
//# sourceMappingURL=SwipeListItem.js.map